import { get, post, put } from './axios';

import { GET_SESSION_API, GET_SESSION_DETAIL_API } from '../commons/constants/apis';
import { PageRequest, PaginationResponseTypes, ResponseTypes } from '../types/response';
import { SessionTypes } from '../types/session.type';
import { ContractCategoryTypes } from '../types/contractCategory.type';

type SessionRequestType = {
  projectId: string;
  projectItemIds?: string;
  floorIds?: string;
  agentIds?: string;
  status?: string;
  name?: string;
};

export const getSessions = async (
  request: SessionRequestType & PageRequest
): Promise<PaginationResponseTypes<SessionTypes[]>> => {
  let res: PaginationResponseTypes<SessionTypes[]>;
  try {
    const { ...rest } = request;

    res = await get(`${GET_SESSION_API}`, {
      params: { ...rest },
    });
  } catch (e) {
    console.error(e);
    return null;
  }
  return res;
};

export const getSessionByCode = async (code: string): Promise<ResponseTypes<SessionTypes>> => {
  let res: ResponseTypes<SessionTypes>;
  try {
    res = await get(`${GET_SESSION_DETAIL_API}/${code}`);
  } catch (e) {
    console.error(e);
    return null;
  }
  return res;
};

type UpdatePriceSessionType = {
  sessionId: number;
  price: { [key: string]: number };
};

type UpdateStatusSessionType = {
  sessionId: string;
  status: string;
  sellerId: number[];
};

type sessionTypeRequest = {
  name: string;
  commission: string;
  inventoryProductCode: string;
};

type CreateSessionType = {
  session: sessionTypeRequest;
  sellerIds: number[];
};

type UpdateSessionType = {
  availableDate: string;
  sellerIds: number[];
  commission: number;
  name: string;
  id: string;
  price: { [key: string]: number };
  terms: ContractCategoryTypes[];
  featureIds: number[];
};

export const updatePriceSession = async (
  request: UpdatePriceSessionType
): Promise<ResponseTypes<SessionTypes>> => {
  const { sessionId } = request;
  let res: ResponseTypes<SessionTypes>;

  try {
    res = await put(`${GET_SESSION_API}/${sessionId}/price`, request);
  } catch (e) {
    console.error(e);
    return null;
  }
  return res;
};

export const updateStatusSession = async (
  request: UpdateStatusSessionType
): Promise<ResponseTypes<SessionTypes>> => {
  const { sessionId } = request;
  let res: ResponseTypes<SessionTypes>;

  try {
    res = await put(`${GET_SESSION_API}/${sessionId}/update-status`, request);
  } catch (e) {
    console.error(e);
    return null;
  }
  return res;
};

export const createSession = async (
  request: CreateSessionType
): Promise<ResponseTypes<SessionTypes>> => {
  let res: ResponseTypes<SessionTypes>;

  try {
    res = await post(`${GET_SESSION_API}`, request);
  } catch (e) {
    console.error(e);
    return null;
  }
  return res;
};

export const updateSession = async (
  request: UpdateSessionType
): Promise<ResponseTypes<SessionTypes>> => {
  let res: ResponseTypes<SessionTypes>;
  const { availableDate, sellerIds, commission, name, id, price, terms, featureIds } = request;

  try {
    res = await put(`${GET_SESSION_API}/${id}`, {
      availableDate,
      sellerIds,
      commission,
      name,
      price,
      terms,
      featureIds,
    });
  } catch (e) {
    console.error(e);
    return null;
  }
  return res;
};
